module.exports = __webpack_public_path__ + "media/images/flags/af-0071d92056289494f7ef45ed301b7807.svg";